const o=()=>void 0===globalThis.window;export{o as isServerSide};
